<div *ngIf="user">
    <div>
        <div class="row align-items-center">
            <div class="col-12 col-md-6 form-group">
                <label class="required">{{ "Current password" | translate }}</label>
                <input type="password" value="********" disabled class="form-control" />
            </div>
            <div class="col-12 col-md-6 form-group text-center">
                <button class="btn btn-link" type="button" (click)="changePassword()">
                    <span>{{ "Change your password" | translate }}</span>
                </button>
            </div>
        </div>
    </div>
</div>
